module.exports = __webpack_public_path__ + "images/illustrations/indexer.svg";